import Box from '@mui/material/Box';
import { useCallback, useEffect, useState } from 'react';
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
import { useSnackbar } from 'notistack';
import AlertMessages from 'common/Alert/AlertMessages';
import { useTranslation } from 'react-i18next';
import { Grid, SelectChangeEvent, Typography } from '@mui/material';
import { checkPrivileges } from 'Helpers/CheckPrivileges';
import { useNavigate } from 'react-router-dom';
import FormDialog from 'common/Modal/Modal';
import ComponentHeaderTwo from 'common/ComponentHeaderTwo/ComponentHeaderTwo';
import { ReactComponent as Payment } from "assets/SideBarIcons/money-transfer.svg";
import BackendPaginationTable from 'common/Table/TableWithPagination';
import PaymentSearchHeader from 'components/Payment/PaymentSearchHeader';
// import { PaymentProfileService } from 'subModule/src/core/services';
// import { PaymentsResponse } from 'subModule/src/services/payment/interface';
// import { DeleteData } from 'subModule/src/type';
import Loader from 'layout/Loader';
import { useGetPaymentService } from 'subModule/src/services/payment/usePayments';
// import ButtonNew from 'common/Button/Button';
import CommonCheckbox from "common/CheckBox/Checkbox";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from 'react-redux';
import { brandingInfo } from 'features/server/brandingSlice';
import { themes } from 'theme/themes';
interface SearchFormData {
    [key: string]: string | any;
}
interface PaymentProps {
    userId?: number;
    accountId?: number;
    type?: 'client' | 'customer' | 'vehicle';
    vehicleId?: number;
}
export default function PaymentListing(props: PaymentProps) {
    const navigate = useNavigate();
    const { control, watch } = useForm({});
    const branding = useSelector(brandingInfo);
    const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
    const [openDeleteModal, setDeleteModal] = useState(false);
    const [pageNo, setPageNo] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(props?.type ? 5 : 20);
    const [loading, setLoading] = useState<boolean>(false);
    const [filter, setFilter] = useState<string[]>(['paymentNo']);
    const [search, setSearch] = useState<any>({});
    // const [row, setRow] = useState<PaymentsResponse>({});
    const [searchFormData, setSearchFormData] = useState<SearchFormData>({ paymentNo: '', clientName: '', start: null, end: null });
    const { data: tableData, isFetching, refetch } = useGetPaymentService({ 
        pageNumber: pageNo, size: pageSize, ...search, typeName: props?.vehicleId ? 'payments/byvehicleid' : 'payments/paged',
        ...(props?.accountId && !watch('checkInvoice') && { accountId: props.accountId }), 
        ...(((props?.userId && watch('checkInvoice')) || (props?.type === 'customer' && props?.userId)) && { userId: props.userId }), 
        ...(props?.vehicleId && { vehicleId: props.vehicleId }), 
    });
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const fetchData = useCallback(() => {
        refetch().then((res: any) => {
            if (!res?.data?.pages[0]?.success) enqueueSnackbar(<AlertMessages text={res?.data?.pages[0]?.message || "Something went wrong"} />, { variant: "error" });
        }).finally(() => setLoading(false));
    }, []);
    useEffect(() => {
        fetchData();
    }, [pageNo, pageSize, search]);
    useEffect(() => {
        if (loading) handleSubmitSearch();
    }, [searchFormData.start, searchFormData.end]);
    const handleChangePage = (pageNo: number) => {
        setPageNo(pageNo + 1);
    }
    const handleChangeRows = (pageSize: number) => {
        setPageSize(pageSize);
        setPageNo(1);
    }
    // const onEdit = (row: any) => navigate('/payment/' + row.id);
    const showRowView = (row: any) => navigate('/payment/' + row.id);
    // const onDelete = (row: any) => {
    //     setDeleteModal(true);
    //     setRow(row);
    // }
    const clearSearch = () => {
        setFilter(['paymentNo']);
        setSearchFormData({ paymentNo: '', clientName: '', start: null, end: null });
        if (Object.keys(search).length) {
            setSearch({});
        }
    }
    const handleChangeFilter = (event: SelectChangeEvent<typeof filter>) => {
        const { target: { value }, } = event;
        setFilter(typeof value === 'string' ? value.split(',') : value,);
        setSearchFormData(prevFormData => {
            const selectedFilters = typeof value === 'string' ? value.split(',') : value;
            const updatedFormData = Object.fromEntries(Object.keys(prevFormData).map(key =>
                [key, value.includes(key) ? prevFormData[key] : '']
            ));
            if (selectedFilters.includes('dateInterval')) {
                updatedFormData.start = prevFormData.start;
                updatedFormData.end = prevFormData.end;
            }
            return updatedFormData;
        });
        if (!value.length && Object.keys(search).length) {
            clearSearch();
        }
    };
    const handleChangeSearch = (field: string, value: any) => {
        const val = value;
        if(field === 'dateInterval') {
            setSearchFormData((prevData) => ({
                ...prevData,
                start: value[0],
                end: value[1]
            }));
            if ((value[0] && value[1]) || ((value[0] === null) && (value[1] === null))) {
                setLoading(true);
            }
        } else {
            setSearchFormData((prevData) => ({
                ...prevData,
                [field]: val,
            }));
        }
    };
    const handleSubmitSearch = () => {
        const filteredSearch: Record<string, string> = {};
        const { start, end, ...rest } = searchFormData;
        if (start && end) {
            filteredSearch.start = start;
            filteredSearch.end = end;
        } else {
            // ❗ If one or both missing → remove both
            setSearchFormData((prev) => ({
                ...prev,
                start: null,
                end: null,
            }));
        }
        Object.entries(rest).forEach(([key, value]) => {
            if (value) {
                filteredSearch[key] = value?.trim();
            }
        });
        setSearch(filteredSearch);
        setPageNo(1);
        setPageSize(pageSize);
    };
    // const actionslist = [
    //     { label: "edit", onClick: onEdit, icon: <EditIcon /> },
    //     { label: "delete", onClick: onDelete, icon: <DeleteIcon /> },
    // ];
    // const adjustActions = (actions: any[]) => {
    //     return checkPrivileges('ROLE_PAYMENT_UPDATE')
    //         ? (checkPrivileges('ROLE_PAYMENT_ARCHIVE')
    //             ? actions
    //             : actions.filter(action => action.label !== 'delete'))
    //         : (checkPrivileges('ROLE_PAYMENT_ARCHIVE')
    //             ? actions.filter(action => action.label !== 'edit')
    //             : []);
    // }
    return (
        <Box>
            {props?.type ? null : <ComponentHeaderTwo
                showBtn={true}
                showSaveBtn={false}
                onClick={() => navigate('/payment/create')}
                heading={t('payments')}
                icon={<Payment height={28} width={28} />}
                btnText={"create"}
                btnType={"create"}
                showCreateBtn={checkPrivileges("ROLE_PAYMENT_CREATE")}
            />}
            {(isFetching || loading) ? <Loader /> : <BackendPaginationTable
                columns={[
                    { id: 'paymentNo', label: 'Payment Number', numeric: false },
                    // { id: 'referenceNo', label: 'referenceNo', numeric: false },
                    { id: 'paymentModeTitle', label: 'PaymentMode', numeric: false },
                    { id: 'clientName', label: props?.type === 'customer' ? 'customerName' : 'clientName', numeric: false },
                    { id: 'amount', label: 'amount', numeric: false },
                    { id: 'paymentDate', label: 'paymentDate', numeric: false },
                    { id: 'adjustmentType', label: 'adjustmentType', numeric: false },
                    // ...(adjustActions(actionslist).length && !props?.type ? [{ id: 'actions', label: 'actions', numeric: false }] : []),
                ]}
                data={tableData?.pages[0]?.data?.content || []}
                pageNo={pageNo}
                pageSize={pageSize}
                tableData={tableData?.pages[0]?.data || {}}
                showCheckbox={false}
                showActions={true}
                enableSorting={true}
                showHeader={true}
                showSearch={true}
                showFilter={true}
                showCreateButton={true}
                // actions={adjustActions(actionslist)}
                handleChangePage={handleChangePage}
                handleChangeRows={handleChangeRows}
                rowClick={true}
                showRowView={showRowView}
                // showRowView={showRowView}
                loadingSearch={false}
                headerComponent={
                  <>
                    <Box className="table-header-search">
                      <PaymentSearchHeader
                        searchFormData={searchFormData}
                        handleChangeFilter={handleChangeFilter}
                        handleChangeSearch={handleChangeSearch}
                        handleSubmitSearch={handleSubmitSearch}
                        clearSearch={clearSearch}
                        {...{ filter, search }}
                      />
                    </Box>
                    {props?.type === 'client' ? (
                      <Box className="table-header-actions">
                        <Controller
                          name="checkInvoice"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <Box sx={{
                              '& .MuiTypography-root': { fontSize: '11px', lineHeight: '16px' },
                              '& svg': {width: '30px', height: '30px'},
                              '& label': { width: 'max-content', margin: '0' }
                            }}>
                              <CommonCheckbox
                                {...field}
                                label={t("Individual") + ' ' + t("Payment")}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                  field.onChange(event.target.checked);
                                  setSearch({...search});
                                }}
                                checked={field.value}
                                color={themeColors?.primary}
                              />
                            </Box>
                          )}
                        />
                      </Box>
                    ) : null}
                  </>
                }
            />}
            {openDeleteModal &&
                <FormDialog
                    open={openDeleteModal}
                    onClose={() => setDeleteModal(false)}
                    title={t('delete') + ' ' + t('Payment')}
                    content={
                        <Grid container >
                            <Grid item xs={12}  >
                                <Typography>{t("Are you sure you want to delete?")}</Typography>
                            </Grid>
                        </Grid>
                    }
                    saveFunction={() => {
                        setDeleteModal(false);
                        setLoading(true);
                        // PaymentProfileService.deletePayment((row as any).id).then((response: DeleteData) => {
                        //     if (response.success) {
                        //         if (tableData?.pages[0]?.data?.content?.length === 1 && (pageNo > 1)) setPageNo(1);
                        //         else refetch();
                        //         enqueueSnackbar(<AlertMessages statusCode={response.status} text={t('Payment') + ' ' + t('deleted') + ' ' + t('successfully')} />, { variant: 'success' });
                        //     } else {
                        //         enqueueSnackbar(<AlertMessages statusCode={response.status} />, { variant: 'error' });
                        //     }
                        // }).catch((err: any) => {
                        //     console.error("===", err);
                        //     enqueueSnackbar(<AlertMessages text={err?.data?.message || err || "Something went wrong"} />, { variant: 'error' });
                        // }).finally(() => setLoading(false));
                    }}
                    submitButtonText="Delete"
                />}
        </Box>
    )
}